import { gql } from "lib/apolloClient";

/**
 * Fragment for staff courses used in School Library queries
 */
export const staffUnitPlanFragment = {
  staffCourses: gql`
    fragment staffCoursesItem on Staff {
      id
      firstName
      middleName
      lastName
      profileImage
      preferredName
      prefix
      suffix
      pronouns
      email
      roles
      type
      role
      isArchived
      courses {
        id
        title @skip(if: $skipTitle)
      }
    }
  `,
};
